import React from 'react';
import { Helmet } from 'react-helmet';
import { Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Navbar from './navbar.jsx';
import Intro from './intro.jsx';
import Problems from './problems.jsx';
import SocialProof from './social-proof.jsx';
import About from './about.jsx';
import Contact from './contact.jsx';
import FloatingCta from './floating-cta.jsx';
import BackToTop from './back-top.jsx';
import Preloader from './preloader';
import ServicePage from './servizi/ServicePage.jsx';
import PrivacyPolicy from './PrivacyPolicy.jsx';
import CookiePolicy from './CookiePolicy.jsx';

import { CookieConsentProvider } from '../gdpr/CookieConsentContext';
import ConsentScriptManager from '../gdpr/ConsentScriptManager';
import CookieBanner from '../gdpr/CookieBanner';
import Footer from './Footer.jsx';

const HomePage = () => {
	const { t, i18n } = useTranslation();
	return (
		<React.Fragment>
			<Helmet>
				<html lang={i18n.language} />
				<title>{t('meta.homeTitle')}</title>
				<meta name="description" content={t('meta.homeDescription')} />
				<meta name="keywords" content="studio ingegneria Roma, ingegneria informatica, intelligenza artificiale, sviluppo web, cybersecurity, data engineering, cloud computing, consulenza IT, Eleonora Bernasconi" />
				<link rel="canonical" href="https://www.ingegneriabernasconi.it/" />
				<meta property="og:title" content={t('meta.homeTitle')} />
				<meta property="og:description" content={t('meta.homeOgDescription')} />
				<meta property="og:url" content="https://www.ingegneriabernasconi.it/" />
				<meta property="og:type" content="website" />
			</Helmet>
			<Intro />
			<Problems />
			<SocialProof />
			<About />
			<Contact />
			<FloatingCta />
			<BackToTop />
		</React.Fragment>
	);
};

const App = () => (
	<CookieConsentProvider>
		<Navbar />
		<Routes>
			<Route path="/" element={<HomePage />} />
			<Route path="/servizi/:slug" element={<ServicePage />} />
			<Route path="/privacy-policy" element={<PrivacyPolicy />} />
			<Route path="/cookie-policy" element={<CookiePolicy />} />
		</Routes>
		<Footer />
		<Preloader />
		<ConsentScriptManager />
		<CookieBanner />
	</CookieConsentProvider>
);

export default App;
